import React from 'react'
import ReactDOM from 'react-dom'
import LoadStyles from '@driftt/tide-core/dist/styles'
import App from './layouts/App'
import { checkForGlobalSession } from '@driftt/web-auth'
import './index.css'

const performCrossSkuAuthCheck = () => {
    checkForGlobalSession()
    .then(renderAppNormally)
    .catch(error => console.error("error checking for global session: " + error))
}

const renderAppNormally = () => {
    const root = document.getElementById('root')
    ReactDOM.render(<App />, root)
    LoadStyles()
}

performCrossSkuAuthCheck()
